import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { Company } from '../../types/company.types';
import { useAppQuery } from '../use-app-query.hook';

export const useCompany = (companyId: string) => {
  const queryClient = useQueryClient();

  const { data: company, isLoading } = useAppQuery<Company>({
    queryKey: [QueryKey.GET_COMPANY, companyId],
    queryFn: () => ApiService.get({ endpoint: BackendRoute.COMPANIES, routePath: [companyId] }),
    enabled: !!companyId,
  });

  const invalidateQuery = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.GET_COMPANY] });
  }, [queryClient]);

  return {
    invalidateQuery,
    company,
    isLoading,
  };
};
